import styled, { css } from 'styled-components';

import { ACQ, ACQ_MOBILE } from '../../../../theme/tokens';
import { hoverWash } from '../../../../theme/mixins';
import { Text } from '../../../../components';

export const Card = styled.div`
  background: ${ACQ.cardOuter};
  border-radius: 16px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SecTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${ACQ.t300};
  padding: 10px 0 10px 5px;
`;

export const Grid = styled.div`
  display: grid;
  /* auto-fit so a single channel spans the full width (no empty half-slot), while
     two channels still sit side by side and narrow widths wrap to one column. */
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 10px;
`;

export const Item = styled.div<{ $locked?: boolean }>`
  background: ${ACQ.cardInner};
  border-radius: 16px;
  padding: 10px 20px;
  height: 117px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Positioning context for the LockVeil (a locked card drops hoverWash, which would
     otherwise establish it). */
  position: relative;
  cursor: ${(p) => (p.$locked ? 'default' : 'pointer')};
  /* Locked: clip the frosted veil to the rounded corners and isolate its stacking so it
     stays contained in the card. */
  overflow: ${(p) => (p.$locked ? 'hidden' : 'visible')};
  ${(p) => (p.$locked ? 'isolation: isolate;' : '')}

  /* Hover/focus affordances only on a LIVE card — a locked card is inert (no wash, no
     chevron nudge, not focusable). */
  ${(p) =>
    p.$locked
      ? ''
      : css`
          ${hoverWash}

          &:hover .chev {
            transform: translateX(2px);
            color: ${ACQ.white};
          }
          &:focus-visible {
            outline: 2px solid ${ACQ.orange};
            outline-offset: 2px;
          }
        `}
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 5px;
  color: ${ACQ.t200};
`;

export const TopLabel = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  color: ${ACQ.t50};
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const Count = styled.span`
  display: flex;
  align-items: baseline;
  gap: 5px;
  min-width: 0;

  ${ACQ_MOBILE} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
`;

export const CountNum = styled(Text)`
  font-size: 24px;
  font-weight: 700;
  color: ${ACQ.t50};
  line-height: 1.1;
`;

export const CountLabel = styled(Text)`
  font-size: 24px;
  font-weight: 700;
  color: ${ACQ.t50};
  line-height: 1.1;

  ${ACQ_MOBILE} {
    font-size: 12px;
    font-weight: 400;
    color: ${ACQ.t400};
    line-height: 1.2;
  }
`;

export const Chev = styled.span`
  display: grid;
  place-items: center;
  color: ${ACQ.t50};
  flex-shrink: 0;
  transition: transform 0.25s ${ACQ.ease}, color 0.2s;
`;
